<script setup lang="ts">
import {
  PhArrowClockwise as ArrowClockwiseIcon,
  PhFileMagnifyingGlass as FileMagnifyingGlassIcon,
  PhWarningCircle as WarningCircleIcon,
} from '@phosphor-icons/vue'

withDefaults(
  defineProps<{
    kind: 'loading' | 'empty' | 'error'
    title?: string
    message?: string
  }>(),
  {
    title: '',
    message: '',
  },
)

const emit = defineEmits<{ retry: [] }>()
</script>

<template>
  <div v-if="kind === 'loading'" class="status-state status-state--loading" aria-live="polite">
    <div class="skeleton skeleton--wide"></div>
    <div class="skeleton skeleton--medium"></div>
    <div class="skeleton-grid">
      <div class="skeleton skeleton--card"></div>
      <div class="skeleton skeleton--card"></div>
    </div>
    <span class="sr-only">正在加载</span>
  </div>

  <div v-else class="status-state" :class="`status-state--${kind}`">
    <WarningCircleIcon v-if="kind === 'error'" :size="32" aria-hidden="true" />
    <FileMagnifyingGlassIcon v-else :size="32" aria-hidden="true" />
    <h2>{{ title || (kind === 'error' ? '暂时无法加载' : '这里还没有内容') }}</h2>
    <p>{{ message || (kind === 'error' ? '请检查网络后重试。' : '完成第一步后，相关内容会显示在这里。') }}</p>
    <button v-if="kind === 'error'" class="button button--secondary" type="button" @click="emit('retry')">
      <ArrowClockwiseIcon :size="18" aria-hidden="true" />
      重新加载
    </button>
    <slot v-else />
  </div>
</template>
